<form
  *ngIf="form && initialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  @if (doubletError) {
    <app-alert
      severity="error"
      header="Nutzer:in existiert bereits"
      [canToggle]="false"
      styleClass="pt-1 pb-3 px-3"
      text="Wählen Sie eine andere E-Mail-Adresse oder einen anderen Anmeldenamen um die Nutzer:in erfolgreich zu speichern.">
    </app-alert>
  }
  <div class="grid">
    <div class="col-6">
      <app-header
        icon="fas fa-id-card"
        text="Basisdaten"
        sub="Geben Sie die Basisdaten der Nutzer:in ein, um ihn zu erstellen oder zu aktualisieren. Bei, freigeben der Nutzer:in werden diese über die angegebene E-Mail benachrichtigt."></app-header>
      <div class="grid">
        <app-form-field-wrapper
          [formField]="form.get('firstName')"
          [label]="'Vorname'"
          [name]="'firstName'"
          [colSize]="6">
          <input
            pInputText
            id="firstName"
            type="text"
            formControlName="firstName"
            class="p-input" />
        </app-form-field-wrapper>
        <app-form-field-wrapper
          [formField]="form.get('lastName')"
          [label]="'Nachname'"
          [name]="'lastName'"
          [colSize]="6">
          <input
            pInputText
            id="lastName"
            type="text"
            formControlName="lastName"
            class="p-input" />
        </app-form-field-wrapper>
        <app-form-field-wrapper
          [formField]="form.get('email')"
          [label]="'E-Mail'"
          [name]="'email'"
          [colSize]="6">
          <input
            pInputText
            id="email"
            type="text"
            formControlName="email"
            class="p-input" />
        </app-form-field-wrapper>
        <app-form-field-wrapper
          [formField]="form.get('username')"
          [label]="'Anmeldename'"
          [name]="'username'"
          [colSize]="6">
          <input
            pInputText
            id="username"
            type="text"
            formControlName="username"
            class="p-input" />
        </app-form-field-wrapper>
        <app-form-field-wrapper
          [formField]="form.get('phone')"
          [label]="'Telefon'"
          [name]="'phone'"
          [colSize]="6">
          <input
            pInputText
            id="phone"
            type="text"
            formControlName="phone"
            class="p-input" />
        </app-form-field-wrapper>
      </div>
      <p-divider />
      <div class="grid">
        <app-form-field-wrapper
          [colSize]="10"
          label="Rechte"
          [name]="'locked'"
          [floatingLabel]="true">
          <p-dropdown
            id="level"
            optionValue="value"
            [options]="userLevelOptions"
            formControlName="level">
            <ng-template pTemplate="selectedItem" let-item>
              <app-dropdown-option [item]="item" />
            </ng-template>
            <ng-template pTemplate="item" let-item>
              <app-dropdown-option [item]="item" />
            </ng-template>
          </p-dropdown>
        </app-form-field-wrapper>
      </div>
      <p-divider />
      <div class="grid">
        <app-form-field-wrapper
          [colSize]="6"
          [label]="'Nutzer:in freigegeben?'"
          [name]="'locked'"
          [floatingLabel]="false">
          <p-inputSwitch
            id="locked"
            [falseValue]="true"
            [trueValue]="false"
            formControlName="locked"></p-inputSwitch>
        </app-form-field-wrapper>

        <!--@if (form.value['level'] === 0) {
          <app-form-field-wrapper
            [colSize]="6"
            [label]="'Administrator:in?'"
            [name]="'isAdmin'"
            [floatingLabel]="false">
            <p-inputSwitch
              id="isAdmin"
              [falseValue]="false"
              [trueValue]="0"
              formControlName="isAdmin"></p-inputSwitch>
          </app-form-field-wrapper>
        }-->
      </div>
    </div>
    <div class="col-6">
      @if (form.value['level'] === 0) {
        @if (!communeFromRoute) {
          <app-header
            suffix="beta"
            suffixIcon="fas fa-flask"
            icon="fas fa-users-viewfinder"
            sub="Fügen Sie beliebige Arbeitsbereiche hinzu und verknüpfen Sie die Rollen, die für den Arbeitsbereich gelten sollen."
            text="Arbeitsbereiche und Rechte"></app-header>
          <div formArrayName="workspaces" class="grid">
            <ng-container
              *ngFor="
                let workspaceControl of workspacesFormArray.controls;
                let i = index
              "
              [formGroupName]="i">
              <app-form-field-wrapper
                *ngIf="workspaceDropdownItems.length > 0"
                [label]="'Arbeitsbereich'"
                [name]="'workspace'"
                [colSize]="7">
                <p-dropdown
                  [options]="workspaceDropdownItems"
                  optionValue="value"
                  formControlName="workspace">
                  <ng-template pTemplate="selectedItem" let-selectedOption>
                    <div class="flex align-items-center gap-2">
                      <i [class]="selectedOption.icon"></i>
                      @if (selectedOption.iconAddon) {
                        <i
                          class="icon-addon"
                          [class]="selectedOption.iconAddon"></i>
                      }
                      <div>{{ selectedOption.label }}</div>
                    </div>
                  </ng-template>
                  <ng-template let-item pTemplate="item">
                    <div
                      class="flex align-items-baseline gap-2"
                      [ngClass]="{
                        'text-color-secondary font-italic':
                          item.label === 'alle',
                      }">
                      <div class="flex flex-column gap-2">
                        <div class="flex align-items-baseline gap-2">
                          <i [class]="item.icon"></i> {{ item.label }}
                        </div>
                        @if (item.help) {
                          <div
                            class="text-sm text-color-secondary"
                            [innerHTML]="item.help"></div>
                        }
                      </div>
                    </div>
                  </ng-template>
                </p-dropdown>
              </app-form-field-wrapper>

              <app-form-field-wrapper
                [name]="'roles'"
                [colSize]="4"
                *ngIf="roleStore.asArray() as roles">
                <p-button
                  styleClass="w-auto"
                  [outlined]="true"
                  (onClick)="op.toggle($event)"
                  icon="fas fa-user-shield"
                  [pTooltip]="wsTooltipContent"
                  tooltipPosition="left"
                  [badge]="workspaceControl.get('roles')?.value?.length || '0'"
                  badgeClass="bg-primary"
                  label="Rollen" />

                <ng-template #wsTooltipContent>
                  @if (
                    roleStore.getByIds(
                      workspaceControl.get('roles')?.value || []
                    );
                    as wsRoles
                  ) {
                    @if (wsRoles.length > 0) {
                      @for (role of wsRoles; track $index) {
                        @if (!$last) {
                          {{ role.name }},
                        } @else {
                          {{ role.name }}
                        }
                      }
                      <p-divider></p-divider>
                      <app-permission-list
                        [roleIds]="
                          workspaceControl.get('roles')?.value || []
                        "></app-permission-list>
                    } @else {
                      <i>Noch keine Berechtigungen gesetzt</i>
                    }
                  }
                </ng-template>

                <p-overlayPanel #op>
                  <div class="flex flex-column gap-3 w-30rem">
                    <div class="grid">
                      <div class="col-6">
                        <app-header
                          styleClass="text-md mt-2 mb-3"
                          text="Rollen"
                          icon="fas fa-user-shield"></app-header>
                        <div
                          *ngFor="let role of roles"
                          class="field-checkbox"
                          tooltipPosition="left"
                          [pTooltip]="tooltipContent">
                          <p-checkbox
                            [binary]="false"
                            [label]="role.name"
                            [value]="role._id"
                            formControlName="roles">
                          </p-checkbox>
                          <ng-template #tooltipContent>
                            <app-permission-list
                              [plain]="true"
                              [roleIds]="[role._id]"></app-permission-list>
                          </ng-template>
                        </div>
                        <div
                          *ngFor="
                            let template of roleStore.availableTemplates()
                          "
                          class="field-checkbox">
                          <p-button
                            [pTooltip]="templateTooltipContent"
                            tooltipPosition="left"
                            styleClass="button-xs"
                            [size]="'small'"
                            [label]="template.name"
                            [outlined]="true"
                            (click)="
                              addRoleToWsControl(template, workspaceControl)
                            "
                            icon="fas fa-plus-circle"></p-button>
                          <ng-template #templateTooltipContent>
                            <app-permission-list
                              [plain]="true"
                              [templateKey]="
                                template.key
                              "></app-permission-list>
                          </ng-template>
                        </div>
                      </div>
                      <div class="col-6 p-card">
                        <app-header
                          styleClass="text-md mt-2 mb-3"
                          icon="fas fa-arrow-right"
                          text="Berechtigungen"
                          sub="Die Nutzer:in ist berechtigt folgende Aktionen durchzuführen:"></app-header>
                        <div class="flex flex-column gap-1">
                          <app-permission-list
                            [roleIds]="
                              workspaceControl.get('roles')?.value || []
                            "></app-permission-list>
                        </div>
                      </div>
                    </div>
                  </div>
                </p-overlayPanel>
              </app-form-field-wrapper>

              <app-form-field-wrapper [hideLabel]="true" [colSize]="1">
                <p-button
                  (click)="removeWorkspace(i)"
                  icon="fas fa-trash"
                  [severity]="'danger'"
                  [size]="'small'"
                  [rounded]="true"></p-button>
              </app-form-field-wrapper>
            </ng-container>
          </div>

          <div
            *ngIf="!form.value['workspaces'].length"
            role="alert"
            class="p-message p-message-info">
            <div class="p-message-wrapper">
              <span class="p-message-summary"
                >Keine Arbeitsbereiche zugewiesen</span
              >
              <span class="p-message-detail"
                >Nutzer:in hat Zugriff auf alle Daten</span
              >
            </div>
          </div>

          <div class="flex">
            <button
              pButton
              icon="fas fa-circle-plus"
              label="Arbeitsbereich hinzufügen"
              class="p-button-rounded p-button-success w-auto mt-3 ml-auto"
              (click)="addWorkspace()"></button>
          </div>
          <!--
          <h3>Bereiche</h3>
          <div formGroupName="viewAccess">
            <div *ngFor="let access of viewAccess" class="field-checkbox">
              <p-checkbox
                [binary]="true"
                [label]="access.name"
                [checkboxIcon]="access.icon"
                name="accessList"
                [formControlName]="access.key"></p-checkbox>
            </div>
          </div>-->
        }
      } @else {
        <app-header icon="fas fa-info-circle" text="Rechte"></app-header>

        @switch (form.value.level) {
          @case (10) {
            <app-alert
              [canToggle]="false"
              styleClass="p-3 pt-1"
              header="Leserechte"
              icon="fas fa-eye">
              <p>
                Nutzer:innen können alles sehen, jedoch weder löschen,
                editieren, veröffentlichen, importieren oder exportieren.
              </p>
            </app-alert>
          }
          @case (20) {
            <app-alert
              [canToggle]="false"
              styleClass="p-3 pt-1"
              header="Bearbeitungsrechte"
              icon="fas fa-edit">
              <p>
                Nutzer:innen können alles bearbeiten, jedoch keine
                Konfigurationen vornehmen.
              </p>
            </app-alert>
          }
          @default {
            <app-alert
              [canToggle]="false"
              styleClass="p-3 pt-1"
              header="Administrator:in"
              icon="fas fa-user-tie">
              <p>
                Nutzer:innen können den vollen Funktionsumfang des Kommunalatlas
                nutzen.
              </p>
            </app-alert>
          }
        }
      }

      <p-panel [toggleable]="true" [collapsed]="true" styleClass="mt-5">
        <ng-template pTemplate="header">
          <div class="flex align-items-center gap-2">
            <app-header
              styleClass="m-0"
              icon="fas fa-wrench"
              text="Toolzugriff einschränken"
              sub="Aktivieren Sie die Checkboxen, wenn die Nutzer:in nur zu bestimmten Tools Zugriff erhalten soll."></app-header>
          </div>
        </ng-template>
        <div formGroupName="toolAccess">
          <div *ngFor="let access of toolAccess" class="field-checkbox">
            <p-checkbox
              [binary]="true"
              [label]="access.name"
              name="accessList"
              [checkboxIcon]="access.icon"
              [formControlName]="access.key"></p-checkbox>
          </div>
        </div>
      </p-panel>
    </div>
  </div>

  <p-divider></p-divider>
  <app-form-footer
    [cancelLevel]="1"
    [showRemoveButton]="!!itemToEdit"
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit
        ? confirm(undefined, itemToEdit, itemToEdit.username)
        : undefined
    "></app-form-footer>
</form>
